import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SlBriefcase } from "react-icons/sl";
import { BiSearchAlt } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { GrSettingsOption } from "react-icons/gr";
import { HiOutlineUserGroup } from "react-icons/hi";
import "../styles/OurServices.css";

const Welcome = () => {
  const services = [
    {
      icon: <SlBriefcase />,
      title: "Strategic Consulting",
      description: `Tailored business strategies, market entry plans, and growth frameworks to help you thrive in Africa’s evolving business landscape.`,
    },
    {
      icon: <GrSettingsOption />,
      title: "Innovation & Entrepreneurship Programs",
      description: `Empowering young innovators and startups with mentorship, incubation, and access to funding through initiatives like the Young Innovators Challenge.`,
    },
    {
      icon: <FaRegUser />,
      title: "Capacity Building & Training",
      description: `Hands-on workshops, business clinics, and digital skills training to equip changemakers with the tools they need to succeed.`,
    },
    {
      icon: <BiSearchAlt />,
      title: "Research & Insights",
      description: `In-depth market intelligence and impact assessments to inform your decisions and drive data-led innovation.`,
    },
    {
      icon: <HiOutlineUserGroup />,
      title: "Partnership & Ecosystem Development",
      description: `We connect businesses with the right networks—investors, mentors, and ecosystem builders—to accelerate impact and scale.`,
    },
  ];

  const [index, setIndex] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(3);

  // Handle responsive layout
  useEffect(() => {
    const updateLayout = () => {
      setCardsPerPage(window.innerWidth < 768 ? 1 : 3);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);

  // Auto-advance slide
  useEffect(() => {
    const interval = setInterval(() => {
      const maxIndex = Math.ceil(services.length / cardsPerPage) - 1;
      setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 4000); // 4 seconds

    return () => clearInterval(interval);
  }, [cardsPerPage, services.length]);

  const visibleServices = services.slice(
    index * cardsPerPage,
    index * cardsPerPage + cardsPerPage
  );

  return (
    <section className="Services-section">
      <section className="Welcome-section">
        <div className="Welcome-container">
          <p className="Welcome-subtitle">Our Multi-functional Approach</p>
          <h2 className="Welcome-heading">
            <span>Integrated Solutions for</span>{" "}
            <span className="light">Growth, Impact, and Sustainability</span>
          </h2>
          <p className="Welcome-description">
            At NexaGrowth Africa, we understand that growth isn’t
            one-dimensional. That’s why we’ve designed a holistic approach that
            supports entrepreneurs, startups, and SMEs through every stage of
            their journey from idea to scale.
          </p>
        </div>
      </section>

      <div className="Ourservices-carousel">
        <AnimatePresence mode="wait">
          {visibleServices.map((service) => (
            <motion.div
              className="Ourservice-card"
              key={service.title}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            >
              <div className="service-icon">
                <span className="Services-icons">{service.icon}</span>
              </div>
              <div className="service-main">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Welcome;
